
import dust from "dustjs-linkedin";


(function(){dust.register("widgets/time",body_0);function body_0(chk,ctx){return chk.helper("formatTime",ctx,{},{"time":ctx.get(["audioTime"], false),"unit":"seconds","unitLength":"_short"});}return body_0;})();

export default 0;
